import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogAction, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

export const ConfirmDialog = ({ open, onOpenChange, title, description, confirmLabel = "Confirmar", danger = false, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid="confirm-dialog" className="rounded-none border-[#0A0A0A]">
      <AlertDialogHeader>
        <AlertDialogTitle data-testid="confirm-title" className="font-display font-black">{title}</AlertDialogTitle>
        <AlertDialogDescription data-testid="confirm-desc">{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="confirm-cancel-btn" className="rounded-none">Cancelar</AlertDialogCancel>
        <AlertDialogAction data-testid="confirm-accept-btn" onClick={onConfirm}
          className={`rounded-none font-bold uppercase tracking-wider ${danger ? "bg-[#B45309] hover:bg-[#92400E] text-white" : ""}`}>
          {confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
